import React from 'react';
import './Menu.scss';
import { NavLink } from 'react-router-dom';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const Menunav = () => {
  const role = localStorage.getItem('userRole') || '';
  const type = localStorage.getItem('userType');
  const paymentFormField = [
    {
      accessorKey: 'paymentDate',
      header: 'Payment Date',
    },
    {
      accessorKey: 'invoiceNo',
      header: 'Invoice No',
    },
    {
      accessorKey: 'purchaseOrder',
      header: 'Purchase Order',
    },
    {
      accessorKey: 'paymentStatus',
      header: 'Payment Status',
    },
    {
      accessorKey: 'paymentType',
      header: 'Payment Type',
    },
    {
      accessorKey: 'transactionId',
      header: 'Transaction Id',
    },
    {
      accessorKey: 'paymentReferenceNo',
      header: 'Payment Reference No.',
    },
    {
      accessorKey: 'paymentAmount',
      header: 'Payment Amount',
    },
  ];
  return (
    <div className="side-bar">
      {['CLIENT_ADMIN', 'SR_ACCOUNTANT'].includes(role) && (
        <Accordion
          defaultExpanded
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Business Management</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to={'/business'}>
              <div className="side-bar-content">Business</div>
            </NavLink>
            <NavLink to={'/business-store'}>
              <div className="side-bar-content">Business Store</div>
            </NavLink>
            <NavLink to={'/business-department'}>
              <div className="side-bar-content">Business Department</div>
            </NavLink>
          </AccordionDetails>
        </Accordion>
      )}
      {[
        'CLIENT_ADMIN',
        'SR_ACCOUNTANT',
        'ACCOUNTANT',
        'DATA_ENTRY',
        'PRODUCTION',
        'CLIENTS',
      ].includes(role) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Order Management</Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to="/business-store-order">
              <div className="side-bar-content">Business Orders</div>
            </NavLink>

            {[
              'CLIENT_ADMIN',
              'SR_ACCOUNTANT',
              'ACCOUNTANT',
              'PRODUCTION',
            ].includes(role) && (
              <>
                <NavLink to="/business-verify">
                  <div className="side-bar-content">Verify Business Order</div>
                </NavLink>

                <NavLink to="/business-delivery-notes">
                  <div className="side-bar-content">
                    Business Delivery Notes
                  </div>
                </NavLink>
                <NavLink to="/garment-summary-note">
                  <div className="side-bar-content">Garment Summary Note</div>
                </NavLink>
              </>
            )}
          </AccordionDetails>
        </Accordion>
      )}

      {['CLIENT_ADMIN', 'SR_ACCOUNTANT', 'ACCOUNTANT', 'PRODUCTION'].includes(
        role,
      ) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Label Management</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to={'/packaging-label'}>
              <div className="side-bar-content">Linen Package Label</div>
            </NavLink>
            <NavLink to={'/trolly-management'}>
              <div className="side-bar-content">Trolly Management</div>
            </NavLink>
            <NavLink to={'/delivery-trolly'}>
              <div className="side-bar-content">Linen Delivery Note</div>
            </NavLink>
            <NavLink to={'/receive-trolly'}>
              <div className="side-bar-content">Receive Trolly</div>
            </NavLink>
            <NavLink to={'/garment-packaging-label'}>
              <div className="side-bar-content">Garment Packaging Label</div>
            </NavLink>
            <NavLink to={'/garment-delivery-trolly'}>
              <div className="side-bar-content">Garment Delivery Note</div>
            </NavLink>
            <NavLink to={'/trolly-inventory-report'}>
              <div className="side-bar-content">Trolly Inventory Report</div>
            </NavLink>
          </AccordionDetails>
        </Accordion>
      )}
      {['CLIENT_ADMIN', 'SR_ACCOUNTANT', 'ACCOUNTANT', 'PRODUCTION'].includes(
        role,
      ) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Laundry Process Management</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to={'/washingLoad'}>
              <div className="side-bar-content">Washing Load</div>
            </NavLink>
            <NavLink to={'/washingReport'}>
              <div className="side-bar-content">Washing Report</div>
            </NavLink>
          </AccordionDetails>
        </Accordion>
      )}
      {['CLIENT_ADMIN', 'SR_ACCOUNTANT'].includes(role) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Product Management</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to={'/product-master'}>
              <div className="side-bar-content">Product Master</div>
            </NavLink>
            <NavLink to={'/price-master'}>
              <div className="side-bar-content">Price Master</div>
            </NavLink>
          </AccordionDetails>
        </Accordion>
      )}
      {type === 'Retail' ? (
        <>
          {' '}
          <NavLink to={'/retail-store-order'}>
            <div className="side-bar-content">Retail Orders</div>
          </NavLink>
          <NavLink to={'/retail-invoices'}>
            <div className="side-bar-content">Retail Store Invoices</div>
          </NavLink>
          <NavLink
            to={'/retail-payments'}
            state={{ paymentFormField: paymentFormField }}
          >
            <div className="side-bar-content">Retail Payments</div>
          </NavLink>
        </>
      ) : null}
      {type === 'Customer' ? (
        <>
          {' '}
          <NavLink to={'/customer'}>
            <div className="side-bar-content">Customer</div>
          </NavLink>
          <NavLink to={'/customer-order'}>
            <div className="side-bar-content">Customer Orders</div>
          </NavLink>
          <NavLink to={'/customer-invoices'}>
            <div className="side-bar-content">Customer Invoices</div>
          </NavLink>
          <NavLink
            to={'/customer-payments'}
            state={{ paymentFormField: paymentFormField }}
          >
            <div className="side-bar-content">Customer Payments</div>
          </NavLink>
        </>
      ) : null}
      {['CLIENT_ADMIN', 'SR_ACCOUNTANT', 'SUPER_ADMIN'].includes(role) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Administration</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            <NavLink to={'/cost-center'}>
              <div className="side-bar-content">Cost Center</div>
            </NavLink>
            <NavLink to={'/processing-center'}>
              <div className="side-bar-content">Processing Center</div>
            </NavLink>
            <NavLink to={'/category'}>
              <div className="side-bar-content">Category</div>
            </NavLink>

            <NavLink to={'/department'}>
              <div className="side-bar-content">Department</div>
            </NavLink>

            <NavLink to={'/mediafile'}>
              <div className="side-bar-content">Media Items</div>
            </NavLink>
            {role === 'CLIENT_ADMIN' && (
              <NavLink to={'/user'}>
                <div className="side-bar-content">User Management</div>
              </NavLink>
            )}
            {(role === 'SUPER_ADMIN' || role === 'CLIENT_ADMIN') && (
              <NavLink to={'/business-user'}>
                <div className="side-bar-content">Business User Management</div>
              </NavLink>
            )}
          </AccordionDetails>
        </Accordion>
      )}
      {[
        'CLIENT_ADMIN',
        'SR_ACCOUNTANT',
        'ACCOUNTANT',
        'PRODUCTION',
        'CLIENTS',
      ].includes(role) && (
        <Accordion
          sx={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
        >
          <AccordionSummary
            sx={{ paddingleft: '10px', textAlign: 'left' }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body1">Reports</Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{ display: 'flex', flexDirection: 'column', padding: '0px' }}
          >
            {role !== 'PRODUCTION' && (
              <NavLink to={'/inhouse'}>
                <div className="side-bar-content">
                  InHouse Sale Summary Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/inhouse-batch'}>
                <div className="side-bar-content">
                  InHouse Batch Summary Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/businesssales'}>
                <div className="side-bar-content">
                  Business Sales Summary Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/business-batch'}>
                <div className="side-bar-content">
                  Business Batch Summary Report
                </div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/dailyRevenue'}>
                <div className="side-bar-content">Daily Revenue Report</div>
              </NavLink>
            )}
            {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/dailyCustomerRevenue'}>
                <div className="side-bar-content">
                  Daily Customer Revenue Report
                </div>
              </NavLink>
            )}
            {/* {role !== 'PRODUCTION' && role !== 'CLIENTS' && (
              <NavLink to={'/revenuePerKiloReport'}>
                <div className="side-bar-content">
                  Revenue Per Kilo Report
                </div>
              </NavLink>
            )} */}
            {role !== 'CLIENTS' && (
              <NavLink to={'/openOrderReport'}>
                <div className="side-bar-content">Open Order Report</div>
              </NavLink>
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
};
